import React, { PropsWithChildren } from 'react';
import {
    CancelAllFilters,
    CancelFilter,
    LoadMore,
    ResetFilterControlsCurried,
    SetResultLayout,
    SortResults,
    UpdateFilterControlsCurried,
    UpdateIndexFilterControls,
} from '~/core/useSearchState';
import { GoToResultHandler } from '~/hooks/useGoToResult';

export interface SERPActions {
    loadMore: LoadMore;
    updateIndexFilterControls: UpdateIndexFilterControls;
    updateFilterControls: UpdateFilterControlsCurried;
    resetFilterControls: ResetFilterControlsCurried;
    cancelFilter: CancelFilter;
    cancelAllFilters: CancelAllFilters;
    handleGoToResult: GoToResultHandler;
    sortResults: SortResults;
    setResultLayout: SetResultLayout;
}

const SERPActionsContext = React.createContext<SERPActions | undefined>(undefined);

export interface SERPActionsProviderProps {
    actions: SERPActions;
}

export const SERPActionsProvider: React.FC<PropsWithChildren<SERPActionsProviderProps>> = ({ children, actions }) => (
    <SERPActionsContext.Provider value={actions}>{children}</SERPActionsContext.Provider>
);

export const useSERPActions = () => {
    const searchAPI = React.useContext(SERPActionsContext);
    if (searchAPI === undefined) {
        throw new Error('useSearchAPI must be used within a SearchAPIProvider');
    }
    return searchAPI;
};
